import { testItemsApi } from '@edulastic/api'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { createSelector } from 'reselect'
import { AI_ERROR_MAP } from '../constants/form'

export const namespaceKey = 'aiPassageQuestionGeneration'

// actions constants
export const GENERATE_AI_PASSAGE_QUESTION = `[${namespaceKey}] generate passage question`
export const SET_AI_PASSAGE_QUESTION = `[${namespaceKey}] set state`
export const RESET_AI_PASSAGE_QUESTION_STATE = `[${namespaceKey}] reset state`

// actions
export const generateAIPassageQuestionAction = (payload) => ({
  type: GENERATE_AI_PASSAGE_QUESTION,
  payload,
})

export const setAIPassageQuestionStateAction = (payload) => ({
  type: SET_AI_PASSAGE_QUESTION,
  payload,
})

export const resetAIPassageQuestionStateAction = () => ({
  type: RESET_AI_PASSAGE_QUESTION_STATE,
})

// selectors
export const stateSelector = (state) => state?.[namespaceKey]

export const getAIPassageQuestionState = createSelector(
  stateSelector,
  (state) => state || {}
)

// initial state
const initialState = {
  apiStatus: null,
  result: null,
  requestedData: null,
  errorMessage: null,
}

// reducer
export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_AI_PASSAGE_QUESTION:
      return {
        ...state,
        ...payload,
      }
    case RESET_AI_PASSAGE_QUESTION_STATE:
      return {
        ...initialState,
      }
    default:
      return state
  }
}

// sagas
function* generateAIPassageQuestionSaga({ payload }) {
  const generalErrorMessage = 'Something went wrong'

  try {
    yield put(
      setAIPassageQuestionStateAction({
        apiStatus: 'INITIATED',
        result: null,
        errorMessage: null,
        requestedData: null,
      })
    )
    const { result } = yield call(testItemsApi.generateQuestionViaAI, payload)
    yield put(
      setAIPassageQuestionStateAction({
        apiStatus: 'SUCCESS',
        result,
        errorMessage: null,
        requestedData: { ...payload },
      })
    )
  } catch (err) {
    const aiErrorMessage = AI_ERROR_MAP?.[err?.message]
    yield put(
      setAIPassageQuestionStateAction({
        apiStatus: 'FAILED',
        result: null,
        exact: !!aiErrorMessage,
        errorMessage: aiErrorMessage || err?.message || generalErrorMessage,
        requestedData: null,
      })
    )
  }
}

export function* watcherSaga() {
  yield all([
    takeEvery(GENERATE_AI_PASSAGE_QUESTION, generateAIPassageQuestionSaga),
  ])
}
